import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Navbar from './Navbar';
import Header from './Header';

const propTypes = {
  location: PropTypes.shape({}).isRequired,
  routes: PropTypes.arrayOf(PropTypes.shape({})),
  pageName: PropTypes.string.isRequired,
};

const defaultProps = {
  routes: [],
};

function PageHeader({ location, routes, pageName }) {
  return (
    <Fragment>
      <Header pageName={pageName} />
      <Navbar location={location} routes={routes} />
    </Fragment>
  );
}

PageHeader.propTypes = propTypes;
PageHeader.defaultProps = defaultProps;

export default PageHeader;
